import React from 'react';
import FormattedHelmet from '../cmp/intl/FormattedHelmet';
import {connect} from 'react-redux';
import CreativesGrid from './creatives/CreativesGrid';
import FileUploadMarketingPage from './fileupload/FileUploadMarketingPage';
import ProductLinksSection from './marketing-tools/ProductLinksSection';

function OffersPage ({aff_product_linker, aff_file_upload, aff_media_assets, link_type}) {
    return (
            <>
                <FormattedHelmet id={'Marketing Tools'}/>
                <div className={'mb-4'}>
                    {
                        aff_product_linker && link_type > -1 && <ProductLinksSection />
                    }
                    {
                        aff_file_upload && <FileUploadMarketingPage/>
                    }
                    {
                        aff_media_assets && <CreativesGrid/>
                    }
                </div>
            </>
        );
}



function mapStateToProps(state) {
    const {
        is_redirect,
        show_site_stripe, website, ref_code, subscription, aff_file_upload, aff_show_product_commissions} = state.settings
    return {
        link_type: Number(is_redirect),
        show_site_stripe, website, ref_code, subscription, aff_file_upload,
        aff_show_product_commissions,
        aff_media_assets: state.settings.aff_media_assets === undefined ? true : state.settings.aff_media_assets,
        aff_product_linker: state.settings.aff_product_linker === undefined ? true : state.settings.aff_product_linker
    };
}

export default connect(mapStateToProps)(OffersPage);
